// @ts-nocheck
/**
 * ツインキーシステム - 役割別汎用スキル
 *
 * 18種のスキル（3役割 × 2コスト帯 × 3スキル）
 * 仕様書: twin_key_generic_skills_passives_v1.md
 */

import { COST_BANDS, ROLE_CATEGORIES } from '../categoryMapping';
import { SKILL_EFFECT_TYPES, BUFF_TYPES, STATUS_TYPES } from './attributeSkills';

// ========================================
// ヒーラー役割スキル（6種）
// スピリット、天使、エンジェル、マーメイド
// ========================================

export const HEALER_SKILLS = {
  [COST_BANDS.LOW]: [
    {
      id: 'healer_low_1',
      name: 'ヒールライト',
      description: '味方単体HP40%回復',
      skillSlot: 1,
      unlockLevel: 20,
      cooldown: 2,
      effects: [
        { type: SKILL_EFFECT_TYPES.HEAL_SINGLE, healPercent: 0.4 },
      ],
    },
    {
      id: 'healer_low_2',
      name: 'リジェネレーション',
      description: '味方単体に再生×2付与（3T）',
      skillSlot: 2,
      unlockLevel: 40,
      cooldown: 3,
      effects: [
        { type: SKILL_EFFECT_TYPES.BUFF_SINGLE, buff: BUFF_TYPES.REGEN, stacks: 2, duration: 3 },
      ],
    },
    {
      id: 'healer_low_3',
      name: 'サークルヒール',
      description: '味方全体HP35%回復',
      skillSlot: 3,
      unlockLevel: 60,
      cooldown: 5,
      initialCooldown: 3,
      effects: [
        { type: SKILL_EFFECT_TYPES.HEAL_ALL, healPercent: 0.35 },
      ],
    },
  ],
  [COST_BANDS.MID]: [
    {
      id: 'healer_mid_1',
      name: 'キュアライト',
      description: '味方単体HP50%回復、状態異常1つ解除',
      skillSlot: 1,
      unlockLevel: 20,
      cooldown: 2,
      effects: [
        { type: SKILL_EFFECT_TYPES.HEAL_SINGLE, healPercent: 0.5 },
        { type: SKILL_EFFECT_TYPES.STATUS_CURE, count: 1 },
      ],
    },
    {
      id: 'healer_mid_2',
      name: '聖域の加護',
      description: '味方全体に再生×1、防御↑×1付与（3T）',
      skillSlot: 2,
      unlockLevel: 40,
      cooldown: 3,
      effects: [
        { type: SKILL_EFFECT_TYPES.BUFF_ALL, buff: BUFF_TYPES.REGEN, stacks: 1, duration: 3 },
        { type: SKILL_EFFECT_TYPES.BUFF_ALL, buff: BUFF_TYPES.DEF_UP, stacks: 1, duration: 3 },
      ],
    },
    {
      id: 'healer_mid_3',
      name: 'リザレクション',
      description: '味方単体をHP30%で蘇生 or 生存時HP70%回復',
      skillSlot: 3,
      unlockLevel: 60,
      cooldown: 5,
      initialCooldown: 3,
      effects: [
        { type: SKILL_EFFECT_TYPES.REVIVE, revivePercent: 0.3, aliveHealPercent: 0.7 },
      ],
    },
  ],
};

// ========================================
// タンク役割スキル（6種）
// ゴーレム、ガーディアン、マシン
// ========================================

export const TANK_SKILLS = {
  [COST_BANDS.LOW]: [
    {
      id: 'tank_low_1',
      name: 'シールドバッシュ',
      description: '敵単体に攻撃×1.0ダメージ、自身に防御↑×1付与',
      skillSlot: 1,
      unlockLevel: 20,
      cooldown: 2,
      effects: [
        { type: SKILL_EFFECT_TYPES.DAMAGE_SINGLE, multiplier: 1.0 },
        { type: SKILL_EFFECT_TYPES.BUFF_SELF, buff: BUFF_TYPES.DEF_UP, stacks: 1, duration: 3 },
      ],
    },
    {
      id: 'tank_low_2',
      name: '挑発',
      description: '敵全体のターゲットを自身に集中（2T）',
      skillSlot: 2,
      unlockLevel: 40,
      cooldown: 3,
      effects: [
        { type: SKILL_EFFECT_TYPES.BUFF_SELF, buff: BUFF_TYPES.TAUNT, stacks: 1, duration: 2 },
      ],
    },
    {
      id: 'tank_low_3',
      name: 'アイアンフォートレス',
      description: '自身に防御↑×3付与（3T）、被ダメ-20%（3T）',
      skillSlot: 3,
      unlockLevel: 60,
      cooldown: 5,
      initialCooldown: 3,
      effects: [
        { type: SKILL_EFFECT_TYPES.BUFF_SELF, buff: BUFF_TYPES.DEF_UP, stacks: 3, duration: 3 },
        { type: SKILL_EFFECT_TYPES.BUFF_SELF, buff: BUFF_TYPES.DAMAGE_REDUCE, value: 0.2, duration: 3 },
      ],
    },
  ],
  [COST_BANDS.MID]: [
    {
      id: 'tank_mid_1',
      name: 'ヘヴィストライク',
      description: '敵単体に攻撃×1.2ダメージ、スタン付与（15%）',
      skillSlot: 1,
      unlockLevel: 20,
      cooldown: 2,
      effects: [
        { type: SKILL_EFFECT_TYPES.DAMAGE_AND_STATUS, multiplier: 1.2, status: 'stun', chance: 0.15 },
      ],
    },
    {
      id: 'tank_mid_2',
      name: '鉄壁の構え',
      description: '自身に防御↑×2付与、味方全体の被ダメ-10%（2T）',
      skillSlot: 2,
      unlockLevel: 40,
      cooldown: 3,
      effects: [
        { type: SKILL_EFFECT_TYPES.BUFF_SELF, buff: BUFF_TYPES.DEF_UP, stacks: 2, duration: 3 },
        { type: SKILL_EFFECT_TYPES.BUFF_ALL, buff: BUFF_TYPES.DAMAGE_REDUCE, value: 0.1, duration: 2 },
      ],
    },
    {
      id: 'tank_mid_3',
      name: '不落の城塞',
      description: '自身に1回無敵付与、挑発（3T）、反撃×1付与（3T）',
      skillSlot: 3,
      unlockLevel: 60,
      cooldown: 5,
      initialCooldown: 3,
      effects: [
        { type: SKILL_EFFECT_TYPES.BUFF_SELF, buff: BUFF_TYPES.INVINCIBLE, stacks: 1 },
        { type: SKILL_EFFECT_TYPES.BUFF_SELF, buff: BUFF_TYPES.TAUNT, stacks: 1, duration: 3 },
        { type: SKILL_EFFECT_TYPES.BUFF_SELF, buff: BUFF_TYPES.COUNTER, stacks: 1, duration: 3 },
      ],
    },
  ],
};

// ========================================
// スピード役割スキル（6種）
// インセクト、鳥系
// ========================================

export const SPEED_SKILLS = {
  [COST_BANDS.LOW]: [
    {
      id: 'speed_low_1',
      name: 'クイックスラッシュ',
      description: '敵単体に攻撃×1.1ダメージ×2回',
      skillSlot: 1,
      unlockLevel: 20,
      cooldown: 2,
      effects: [
        { type: SKILL_EFFECT_TYPES.DAMAGE_MULTI_HIT, multiplier: 1.1, hits: 2 },
      ],
    },
    {
      id: 'speed_low_2',
      name: '疾風の舞',
      description: '自身に速度↑×2、回避↑×1付与（3T）',
      skillSlot: 2,
      unlockLevel: 40,
      cooldown: 3,
      effects: [
        { type: SKILL_EFFECT_TYPES.BUFF_SELF, buff: BUFF_TYPES.SPD_UP, stacks: 2, duration: 3 },
        { type: SKILL_EFFECT_TYPES.BUFF_SELF, buff: BUFF_TYPES.EVASION_UP, stacks: 1, duration: 3 },
      ],
    },
    {
      id: 'speed_low_3',
      name: '乱れ撃ち',
      description: '敵ランダム3体に攻撃×0.8ダメージ',
      skillSlot: 3,
      unlockLevel: 60,
      cooldown: 5,
      initialCooldown: 3,
      effects: [
        { type: SKILL_EFFECT_TYPES.DAMAGE_RANDOM, multiplier: 0.8, targets: 3 },
      ],
    },
  ],
  [COST_BANDS.MID]: [
    {
      id: 'speed_mid_1',
      name: 'ソニックエッジ',
      description: '敵単体に攻撃×1.2ダメージ×2回、速度↓×1付与',
      skillSlot: 1,
      unlockLevel: 20,
      cooldown: 2,
      effects: [
        { type: SKILL_EFFECT_TYPES.DAMAGE_MULTI_HIT, multiplier: 1.2, hits: 2 },
        { type: SKILL_EFFECT_TYPES.DEBUFF_SINGLE, debuff: BUFF_TYPES.SPD_DOWN, stacks: 1 },
      ],
    },
    {
      id: 'speed_mid_2',
      name: '神速の領域',
      description: '味方全体に速度↑×1付与（3T）、自身は追加で回避↑×1',
      skillSlot: 2,
      unlockLevel: 40,
      cooldown: 3,
      effects: [
        { type: SKILL_EFFECT_TYPES.BUFF_ALL, buff: BUFF_TYPES.SPD_UP, stacks: 1, duration: 3 },
        { type: SKILL_EFFECT_TYPES.BUFF_SELF, buff: BUFF_TYPES.EVASION_UP, stacks: 1, duration: 3 },
      ],
    },
    {
      id: 'speed_mid_3',
      name: 'ブリッツレイン',
      description: '敵ランダム5体に攻撃×0.7ダメージ、30%で攻撃↓×1付与',
      skillSlot: 3,
      unlockLevel: 60,
      cooldown: 5,
      initialCooldown: 3,
      effects: [
        { type: SKILL_EFFECT_TYPES.DAMAGE_RANDOM, multiplier: 0.7, targets: 5 },
        { type: SKILL_EFFECT_TYPES.DEBUFF_ALL, debuff: BUFF_TYPES.ATK_DOWN, stacks: 1, chance: 0.3 },
      ],
    },
  ],
};

// ========================================
// 役割スキルマップ
// ========================================

export const ROLE_SKILLS = {
  [ROLE_CATEGORIES.HEALER]: HEALER_SKILLS,
  [ROLE_CATEGORIES.TANK]: TANK_SKILLS,
  [ROLE_CATEGORIES.SPEED]: SPEED_SKILLS,
};

/**
 * 役割とコスト帯からスキルセットを取得
 * @param {string} roleCategory - 役割カテゴリID
 * @param {string} costBand - コスト帯
 * @returns {Object[]|null} スキル配列（3つ）、役割なしはnull
 */
export const getRoleSkills = (roleCategory, costBand) => {
  if (!roleCategory) return null;

  const roleSkillSet = ROLE_SKILLS[roleCategory];
  if (!roleSkillSet) return null;

  return roleSkillSet[costBand] || roleSkillSet[COST_BANDS.LOW];
};

export default {
  HEALER_SKILLS,
  TANK_SKILLS,
  SPEED_SKILLS,
  ROLE_SKILLS,
  getRoleSkills,
};
